import React, { useState, useEffect, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import axios from "axios";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import { mediaUrl, baseURL } from "../../axiosInterceptor/axiosInterceptorC";
import OwlCarousel from "react-owl-carousel3";

const path = "/keralaplots/";

function HomeAgent() {
  const [isLoading, setIsLoading] = useState(true);
  const [agentdetails, setAgentDetails] = useState([]);
  const carouselRef = useRef(null); // Reference for carousel

  useEffect(() => {
    fetchAgentDetails();
  }, []);

  const fetchAgentDetails = async () => {
    try {
      const response = await axios.post(`${baseURL}/fetchAgentdetails`);
      if (response.data) {
        setAgentDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching agent details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const settings = {
    dots: false,
    loop: true,
    nav: false, // Disable default navigation
    margin: 20,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
      1200: { items: 4 },
    },
  };

  // Custom Next & Prev Handlers
  const goToNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const goToPrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  return (
    <section id="homeAgent">
      <div className="container">
        <div className="homeAgentHead">
          <h2 className="title">Connect with Top Real Estate Agents</h2>
          <p>
            Find reliable real estate agents in your area. Connect with experts to buy,
            sell, or rent properties effortlessly and with confidence.
          </p>
        </div>
        <div className="homeAgentMain">
          {isLoading ? (
            <div className="SkeletonLoader">
              {[...Array(4)].map((_, index) => (
                <div key={index} className="SkeletonLoaderBox">
                  <div className="SkeletonLoaderBoxCol1">
                    <div className="SkeletonLoaderBoxCol2Logo">
                      <Skeleton />
                    </div>
                    <div className="SkeletonLoaderBoxCol2Name">
                      <Skeleton />
                      <Skeleton />
                    </div>
                  </div>
                  <div className="SkeletonLoaderBoxCol2">
                    <Skeleton />
                    <Skeleton />
                  </div>
                </div>
              ))}
            </div>
          ) : agentdetails.length > 0 ? (
            <div className="carouselWrapper">
              {/* Custom Prev Button */}
              <button className="customNavBtn prev" onClick={goToPrev}>
                <GoChevronLeft />
              </button>

              {/* Carousel */}
              <OwlCarousel {...settings} ref={carouselRef}>
                {agentdetails.map((agent, index) => (
                  <a
                    key={index}
                    href={`${path}innerAgent/${agent.loginId}`}
                    target="_blank"
                    className="homeAgentBox"
                  >
                    <div className="homeAgentBoxCol1">
                      <div className="homeAgentBoxThumbnail">
                        <h4>{agent.fullname.charAt(0)}</h4>
                      </div>
                      <div className="homeAgentBoxDetails">
                        <h3 className="agentName">{agent.fullname}</h3>
                        <div className="agentLocation">{agent.town}</div>
                      </div>
                    </div>
                    <div className="homeAgentBoxCol2">
                      <ul>
                        <li>
                          <h4>{agent.experiance_val}</h4>
                          <p>Experience</p>
                        </li>
                        <li>
                          <h4>{agent.total_properties}</h4>
                          <p>Properties</p>
                        </li>
                      </ul>
                    </div>
                  </a>
                ))}
              </OwlCarousel>

              {/* Custom Next Button */}
              <button className="customNavBtn next" onClick={goToNext}>
                <GoChevronRight />
              </button>
            </div>
          ) : (
            <p className="no-data-message">No agents found</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default HomeAgent;
